import TopLevelStatCard from './TopLevelStatCard';
import NewVisitorsAndAverageTimeOnSite from './NewVisitorsAndAverageTimeOnSite';
import { useEffect } from 'react';
import { Tooltip } from 'bootstrap';

export default function TopLevelStats({ endpoints }) {
  const {
    job_applications_count_api_v1_cms_analytics_path,
    jobs_posted_count_api_v1_cms_analytics_path,
    new_visitors_and_average_time_on_site_api_v1_cms_analytics_path,
  } = endpoints;

  useEffect(() => {
    // Instantiate tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <div className="row">
      <div className="col-12 col-lg-6 col-xl">
        <TopLevelStatCard
          title="Applications"
          tooltipTitle="Total applications in current time range"
          icon="fe fe-user-check"
          dataEndpoint={job_applications_count_api_v1_cms_analytics_path}
        />
      </div>

      <div className="col-12 col-lg-6 col-xl">
        <TopLevelStatCard
          title="Jobs Posted"
          tooltipTitle="Jobs posted in current time range"
          icon="fe fe-briefcase"
          dataEndpoint={jobs_posted_count_api_v1_cms_analytics_path}
        />
      </div>

      <NewVisitorsAndAverageTimeOnSite dataEndpoint={new_visitors_and_average_time_on_site_api_v1_cms_analytics_path} />
    </div>
  );
}
